/** UI palette, depths and layout constants (ART_DIRECTION.md "UI" row). */
import { Depth, GAME_H, GAME_W } from '@/core/config';

export const Palette = {
  sand: 0xe2c48c,
  teak: 0x8a5a32,
  lacquer: 0x8c2a22,
  lacquerLight: 0xb3453a,
  lacquerDark: 0x4a1410,
  indigo: 0x2b3a5c,
  indigoDeep: 0x16213a,
  palm: 0x3c7a3a,
  palmLight: 0x8ec95a,
  water: 0x1f8f8a,
  waterLight: 0x6fd3c8,
  storm: 0x3a3f57,
  lantern: 0xffb347,
  parchment: 0xf1e3c2,
  parchmentDark: 0xd9c49a,
  paper: 0xf6ecd6,
  paperEdge: 0xcdb88f,
  ink: 0x2a1d14,
  inkSoft: 0x5a4636,
  night: 0x0b0f14,
} as const;

export const Css = {
  sand: '#e2c48c',
  teak: '#8a5a32',
  lacquer: '#8c2a22',
  lacquerDark: '#4a1410',
  indigo: '#2b3a5c',
  lantern: '#ffb347',
  parchment: '#f1e3c2',
  parchmentDark: '#d9c49a',
  ink: '#2a1d14',
  inkSoft: '#5a4636',
  inkWet: '#4b3a8a',
  white: '#ffffff',
  grey: '#8a8f99',
  dim: '#5a6473',
} as const;

/** Depth bands inside UIScene (all above Depth.UI, below the router curtain at +900). */
export const UiDepth = {
  TOUCH: Depth.UI + 50,
  PROMPT: Depth.UI + 90,
  DIALOGUE: Depth.UI + 100,
  CHOICES: Depth.UI + 120,
  LETTER: Depth.UI + 150,
  HISTORY: Depth.UI + 200,
  PAUSE: Depth.UI + 300,
  TOAST: Depth.UI + 400,
} as const;

export const Layout = {
  W: GAME_W,
  H: GAME_H,
  dialogue: { x: 6, y: 238, w: 628, h: 116, knob: 12, pad: 12 },
  portrait: { x: 22, y: 246, size: 96, frame: 104 },
  bodyFontPx: 16,
  smallFontPx: 12,
} as const;

/** Nine-slice insets for the dev panel textures (the art builder keeps these when swapping). */
export const Slices = {
  scroll: { key: 'ui-scroll-panel', l: 16, r: 16, t: 16, b: 16 },
  paper: { key: 'ui-paper-panel', l: 12, r: 12, t: 12, b: 12 },
  bar: { key: 'ui-lacquer-bar', l: 6, r: 6, t: 6, b: 6 },
  barDim: { key: 'ui-indigo-bar', l: 6, r: 6, t: 6, b: 6 },
} as const;

/** Fixed-size UI textures (dev placeholders in devTextures.ts; the art builder swaps by key). */
export const UiTex = {
  scrollKnob: 'ui-scroll-knob',     // 12x124 rolled scroll end (left; flipX for right)
  waveStrip: 'ui-wave-strip',       // 16x6 repeating gold wave-and-knot ornament
  portraitFrame: 'ui-portrait-frame',
  portraitMissing: 'ui-portrait-missing',
  arrowDown: 'ui-arrow-down',       // 12x8 lacquer continue indicator
} as const;
